import React, { useId } from "react"
import cx from "classnames"
import PropTypes from "prop-types"

const RadioButton = ({
  onKeydown,
  analyticsData,
  contextLabelId,
  id = "",
  name = "",
  value = undefined,
  checked = undefined,
  onClick = () => {},
}) => {
  const optionLabelId = useId()
  return (
    <label onKeyDown={onKeydown} className={cx({ radio: true })} htmlFor={id}>
      <input
        type="radio"
        className={"radio__input " + (analyticsData ? "gbh-data-layer" : "")}
        data-gbh-data-layer={analyticsData}
        name={name}
        id={id}
        checked={checked}
        onClick={onClick}
        onChange={onClick}
        aria-labelledby={
          contextLabelId ? `${optionLabelId} ${contextLabelId}` : undefined
        }
      />
      <span className="radio__custom"></span>
      <span id={contextLabelId ? optionLabelId : undefined}>{value}</span>
    </label>
  )
}

RadioButton.propTypes = {
  id: PropTypes.string,
  contextLabelId: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string || PropTypes.number,
  checked: PropTypes.bool,
  contextLabelId: PropTypes.string,
  onClick: PropTypes.func,
}

export default RadioButton
